import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chatbot');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const require: any;
const showdown = require('showdown');

const chatSessionState: { messages: any[]; inputText: string } = {
    messages: [],
    inputText: ''
};

@Component({
    selector: 'wiz-page-chatbot',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.chatbot/view.scss */
:host {
  display: block;
  height: 100%;
}

.chatbot-page {
  --chat-keyboard-offset: 0px;
  --chat-nav-offset: calc(var(--th-nav-height) + env(safe-area-inset-bottom, 0px));
  --chat-composer-bottom: var(--chat-nav-offset);
  --chat-composer-height: 88px;
  min-height: 0;
}

.chatbot-header-avatar {
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
}

.chatbot-message-avatar {
  width: 40px;
  height: 40px;
}

.chatbot-mascot-graphic {
  transform: scale(0.72);
  transform-origin: center;
}

.chat-messages {
  scroll-behavior: smooth;
  padding-bottom: calc(var(--chat-composer-height) + var(--chat-composer-bottom) + 16px);
}

.chat-message-wrap {
  width: 100%;
  max-width: 100%;
}

.chat-message-wrap-bot .chat-message-content {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  flex: 1 1 auto;
}

.chat-message-wrap-user {
  width: auto;
  max-width: min(86%, 360px);
  margin-left: auto;
}

.chat-bubble {
  width: 100%;
  box-sizing: border-box;
}

.chat-message-wrap-user .chat-bubble {
  width: fit-content;
  min-width: 96px;
  max-width: 100%;
  margin-left: auto;
}

.chat-markdown {
  white-space: normal;
  text-align: left;
  word-break: keep-all;
  overflow-wrap: anywhere;
  line-break: strict;
}

.chat-user-text {
  margin: 0;
  text-align: left;
  white-space: pre-wrap;
  word-break: keep-all;
  overflow-wrap: anywhere;
  line-break: strict;
}

.chat-markdown :first-child {
  margin-top: 0;
}

.chat-markdown :last-child {
  margin-bottom: 0;
}

.chat-markdown p {
  margin: 0 0 0.65rem;
  line-height: 1.65;
}

.chat-markdown ul,
.chat-markdown ol {
  margin: 0.45rem 0 0.65rem 1.2rem;
  padding-left: 1rem;
}

.chat-markdown ul {
  list-style: disc;
}

.chat-markdown ol {
  list-style: decimal;
}

.chat-markdown li {
  margin: 0.2rem 0;
}

.chat-markdown strong,
.chat-markdown b {
  font-weight: 700;
  color: var(--th-text);
}

.chat-markdown a {
  color: var(--th-primary);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.chat-markdown code {
  border-radius: 4px;
  background: rgba(15, 23, 42, 0.08);
  padding: 0.1rem 0.28rem;
  font-size: 0.92em;
}

.chat-markdown pre {
  overflow-x: auto;
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.08);
  padding: 0.75rem;
  white-space: pre-wrap;
}

.chat-markdown pre code {
  background: transparent;
  padding: 0;
}

.chat-markdown blockquote {
  margin: 0.55rem 0;
  border-left: 3px solid var(--th-primary-light);
  padding-left: 0.75rem;
  color: var(--th-text-muted);
}

.chat-markdown table {
  width: 100%;
  border-collapse: collapse;
  margin: 0.65rem 0;
  font-size: 0.95em;
}

.chat-markdown th,
.chat-markdown td {
  border: 1px solid var(--th-line);
  padding: 0.4rem 0.5rem;
  text-align: left;
  vertical-align: top;
}

.quick-replies {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
}

.quick-reply-button {
  display: flex;
  width: 100%;
  min-height: 44px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 14px;
  padding: 10px 14px;
  text-align: left;
  line-height: 1.35;
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  touch-action: manipulation;
}

.chat-composer {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: min(480px, 100vw);
  bottom: var(--chat-composer-bottom);
  z-index: 20;
  background: var(--th-card-bg);
  backdrop-filter: blur(12px);
  box-shadow: 0 -10px 24px rgba(15, 23, 42, 0.08);
}

.chat-input {
  background: var(--th-card-bg);
  border-color: var(--th-line);
  color: var(--th-text);
  caret-color: var(--th-primary);
}

.chat-input::placeholder {
  color: var(--th-text-subtle);
  opacity: 1;
}

.chat-send-button,
.chat-voice-button {
  width: 64px;
  height: 64px;
  touch-action: manipulation;
}

.voice-listening-bubble {
  border: 1px solid var(--th-primary-light);
}

.voice-listening-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--th-primary);
  animation: voice-pulse 1s ease-in-out infinite;
}

.voice-notice-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #f59e0b;
}

.voice-system-message {
  display: inline-flex;
  max-width: calc(100% - 32px);
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 auto;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.06);
  color: var(--th-text-muted);
  padding: 8px 12px;
  text-align: center;
  line-height: 1.35;
  word-break: keep-all;
}

.voice-permission-button {
  border: 1px solid var(--th-primary-light);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.86);
  color: var(--th-primary);
  padding: 4px 10px;
  line-height: 1.2;
  white-space: nowrap;
  touch-action: manipulation;
}

.voice-permission-button:active {
  transform: scale(0.98);
}

@keyframes voice-pulse {
  0%, 100% {
    opacity: 0.35;
    transform: scale(0.85);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}
.animate-bounce {
  animation: bounce 0.6s infinite;
}

@media (orientation: landscape) and (max-height: 520px) {
  .chat-messages {
    padding: 12px;
    padding-bottom: calc(var(--chat-composer-height) + var(--chat-composer-bottom) + 12px);
  }
  .chat-composer {
    padding: 10px 12px;
    width: min(480px, 100vw);
  }
}`],
})
export class PageChatbotComponent implements OnInit, OnDestroy {
    public theme: string = 'b';
    public messages: any[] = [];
    public inputText: string = '';
    public isTyping: boolean = false;
    public isListening: boolean = false;
    public isVoiceSupported: boolean = false;
    public voiceNoticeText: string = '';
    public voicePermissionBlocked: boolean = false;
    private inputFocused: boolean = false;
    private baseViewportHeight: number = 0;
    private lastSendPressAt: number = 0;
    private recognition: any = null;
    private voiceBaseText: string = '';
    private voiceFinalText: string = '';
    private voiceInterimText: string = '';
    private voiceShouldSendOnEnd: boolean = false;
    private voiceSilenceTimer: ReturnType<typeof setTimeout> | null = null;
    private voiceNoticeTimer: ReturnType<typeof setTimeout> | null = null;
    private activeStream: EventSource | null = null;
    private markdownConverter: any;
    private readonly defaultQuickReplies: string[] = ['오늘 컨디션은 어때요?', '잠을 잘 자려면?', '식단은 어떻게 할까요?'];
    private readonly voiceSilenceMs: number = 3000;
    private readonly viewportHandler = () => this.syncChatViewport();
    private readonly windowHandler = () => this.syncChatViewport();
    private readonly outsidePointerHandler = (event: Event) => this.handleOutsidePointer(event);

    constructor(@Inject( Service) public service: Service) {
        this.markdownConverter = new showdown.Converter({
            tables: true,
            strikethrough: true,
            tasklists: true,
            simpleLineBreaks: true,
            openLinksInNewWindow: true
        });
    }

    public async ngOnInit() {
        await this.service.init();
        this.theme = localStorage.getItem('app-theme') || 'b';
        this.isVoiceSupported = !!this.getSpeechRecognitionConstructor();

        if (!chatSessionState.messages.length) {
            chatSessionState.messages.push(this.createGreetingMessage(this.theme));
        }
        this.messages = chatSessionState.messages;
        this.inputText = chatSessionState.inputText;

        await this.service.render();
        this.bindViewportEvents();
        this.baseViewportHeight = this.currentViewportHeight();
        this.syncChatViewport();
        setTimeout(() => this.scrollToBottom(), 80);
    }

    public ngOnDestroy() {
        this.persistChatSession();
        this.closeActiveStream();
        this.destroySpeechRecognition();
        this.clearVoiceSilenceTimer();
        this.clearVoiceNotice();
        this.unbindViewportEvents();
        this.resetChatViewport();
        this.toggleKeyboardMode(false);
    }

    public async sendMessage() {
        const query = this.inputText.trim();
        if (!query || this.isTyping) return;

        this.stopVoiceRecognition(false);
        this.clearVoiceSilenceTimer();

        const userMessage = {
            id: this.messages.length + 1,
            type: 'user',
            text: query,
            time: this.formatTime(new Date())
        };
        this.messages.push(userMessage);
        this.inputText = '';
        this.persistChatSession();
        this.isTyping = true;
        await this.service.render();

        setTimeout(() => this.scrollToBottom(), 100);

        await this.streamBotReply(query);
    }

    public async selectQuickReply(text: string) {
        this.inputText = text;
        await this.sendMessage();
    }

    public async onInputFocus() {
        this.inputFocused = true;
        this.syncChatViewport();
        await this.service.render();
        setTimeout(() => this.scrollToBottom(), 80);
        setTimeout(() => this.syncChatViewport(), 120);
    }

    public async onInputBlur() {
        this.inputFocused = false;
        this.syncChatViewport();
        this.persistChatSession();
        await this.service.render();
    }

    private createGreetingMessage(theme: string): any {
        const greetings: any = {
            a: '안녕하세요! 한의 건강 상담사입니다.\n한의학 양생법을 바탕으로 건강 상담을 도와드립니다.\n\n어떤 도움이 필요하신가요?',
            b: '안녕하세요! AI 건강 상담사입니다.\n한의학 기반으로 건강 관련 질문에 답변해드립니다.\n\n어떤 도움이 필요하신가요?',
            c: '안녕하세요!\n건강에 관해 궁금한 점을 편하게 물어보세요.'
        };
        const text = greetings[theme] || greetings['b'];

        return {
            id: 1,
            type: 'bot',
            text,
            html: this.renderMarkdown(text),
            time: this.formatTime(new Date()),
            quickReplies: this.defaultQuickReplies.slice()
        };
    }

    private persistChatSession() {
        chatSessionState.messages = this.messages;
        chatSessionState.inputText = this.inputText;
    }

    private formatTime(date: Date): string {
        return date.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
    }

    private scrollToBottom() {
        const container = document.querySelector('.chat-messages');
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    }

    private async streamBotReply(query: string) {
        if (typeof EventSource === 'undefined') {
            await this.loadBotReply(query);
            return;
        }

        this.closeActiveStream();

        const source = new EventSource(`${wiz.url('chat_stream')}?message=${encodeURIComponent(query)}`);
        this.activeStream = source;
        let botMessage: any = null;
        let receivedText = '';
        let finished = false;

        source.onmessage = async (event: MessageEvent) => {
            const payload = this.parseStreamPayload(event.data);
            if (!payload) return;

            if (payload.type === 'delta') {
                const text = payload.text || '';
                if (!text) return;

                receivedText += text;
                if (!botMessage) {
                    botMessage = this.addBotMessage('');
                }
                botMessage.text = receivedText;
                this.updateBotMessageHtml(botMessage);
                await this.service.render();
                setTimeout(() => this.scrollToBottom(), 30);
                return;
            }

            if (payload.type === 'error') {
                finished = true;
                this.closeActiveStream(source);
                this.isTyping = false;
                this.addBotMessage(payload.message || '죄송합니다, 일시적인 오류가 발생했습니다.');
                await this.service.render();
                setTimeout(() => this.scrollToBottom(), 80);
                return;
            }

            if (payload.type === 'done') {
                finished = true;
                this.closeActiveStream(source);
                this.isTyping = false;
                const quickReplies = this.normalizeQuickReplies(payload.quickReplies || payload.quick_replies);
                if (botMessage && quickReplies.length) {
                    botMessage.quickReplies = quickReplies;
                }
                if (!receivedText.trim() && !botMessage) {
                    this.addBotMessage('죄송합니다, 답변을 생성하지 못했습니다.');
                }
                await this.service.render();
                setTimeout(() => this.scrollToBottom(), 80);
            }
        };

        source.onerror = async () => {
            if (finished) return;

            finished = true;
            this.closeActiveStream(source);
            this.isTyping = false;
            if (!receivedText.trim()) {
                this.addBotMessage('AI 응답 연결이 끊어졌습니다. 잠시 후 다시 시도해 주세요.');
            }
            await this.service.render();
            setTimeout(() => this.scrollToBottom(), 80);
        };
    }

    private async loadBotReply(query: string) {
        try {
            let res = await wiz.call("chat", { message: query });
            this.isTyping = false;
            const quickReplies = res.code === 200
                ? this.normalizeQuickReplies(res.data.quickReplies || res.data.quick_replies)
                : [];
            this.addBotMessage(res.code === 200 ? res.data.reply : '죄송합니다, 일시적인 오류가 발생했습니다.', quickReplies);
        } catch {
            this.isTyping = false;
            this.addBotMessage('죄송합니다, 일시적인 오류가 발생했습니다.');
        }

        await this.service.render();
        setTimeout(() => this.scrollToBottom(), 100);
    }

    private parseStreamPayload(data: string): any {
        try {
            return JSON.parse(data);
        } catch {
            return data ? { type: 'delta', text: data } : null;
        }
    }

    private addBotMessage(text: string, quickReplies: string[] = []): any {
        const botMessage = {
            id: this.messages.length + 1,
            type: 'bot',
            text,
            html: this.renderMarkdown(text),
            time: this.formatTime(new Date()),
            quickReplies
        };
        this.messages.push(botMessage);
        return botMessage;
    }

    private normalizeQuickReplies(value: any): string[] {
        if (!Array.isArray(value)) return [];

        const replies: string[] = [];
        value.forEach(item => {
            const reply = String(item || '').trim();
            if (!reply || replies.includes(reply)) return;
            replies.push(reply);
        });

        return replies.slice(0, 3);
    }

    private updateBotMessageHtml(message: any) {
        if (!message || message.type !== 'bot') return;
        message.html = this.renderMarkdown(message.text || '');
    }

    private renderMarkdown(text: string): string {
        if (!text) return '';
        return this.markdownConverter.makeHtml(text);
    }

    private closeActiveStream(source?: EventSource) {
        if (source && this.activeStream !== source) {
            source.close();
            return;
        }

        if (this.activeStream) {
            this.activeStream.close();
            this.activeStream = null;
        }
    }

    private bindViewportEvents() {
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.viewportHandler);
            window.visualViewport.addEventListener('scroll', this.viewportHandler);
        }
        document.addEventListener('pointerdown', this.outsidePointerHandler, true);
        if (!('PointerEvent' in window)) {
            document.addEventListener('touchstart', this.outsidePointerHandler, true);
        }
        window.addEventListener('resize', this.windowHandler);
        window.addEventListener('orientationchange', this.windowHandler);
    }

    private unbindViewportEvents() {
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.viewportHandler);
            window.visualViewport.removeEventListener('scroll', this.viewportHandler);
        }
        document.removeEventListener('pointerdown', this.outsidePointerHandler, true);
        document.removeEventListener('touchstart', this.outsidePointerHandler, true);
        window.removeEventListener('resize', this.windowHandler);
        window.removeEventListener('orientationchange', this.windowHandler);
    }

    public async onSendPress(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        const now = Date.now();
        if (now - this.lastSendPressAt < 350) return;
        this.lastSendPressAt = now;

        await this.sendMessage();
        this.focusMessageInput();
    }

    public async onSendClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        if (Date.now() - this.lastSendPressAt < 500) return;
        this.lastSendPressAt = Date.now();

        await this.sendMessage();
        this.focusMessageInput();
    }

    public async toggleVoiceRecognition(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.isTyping) return;

        if (this.isListening) {
            this.stopVoiceRecognition(false);
            return;
        }

        if (this.voicePermissionBlocked) {
            await this.requestMicrophonePermission(event);
            return;
        }

        await this.startVoiceRecognition();
    }

    public async requestMicrophonePermission(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            await this.showVoicePermissionBlockedNotice();
            return;
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            stream.getTracks().forEach(track => track.stop());
            this.clearVoiceNotice();
            await this.service.render();
            await this.startVoiceRecognition();
        } catch {
            await this.showVoicePermissionBlockedNotice();
        }
    }

    private async startVoiceRecognition() {
        const SpeechRecognition = this.getSpeechRecognitionConstructor();
        if (!SpeechRecognition) {
            this.isVoiceSupported = false;
            await this.showVoiceNotice('이 브라우저에서는 음성 인식을 지원하지 않습니다.');
            return;
        }

        this.isVoiceSupported = true;
        this.clearVoiceNotice();
        this.clearVoiceSilenceTimer();
        this.voiceBaseText = this.inputText.trim();
        this.voiceFinalText = '';
        this.voiceInterimText = '';
        this.voiceShouldSendOnEnd = false;

        this.recognition = new SpeechRecognition();
        this.recognition.lang = 'ko-KR';
        this.recognition.continuous = true;
        this.recognition.interimResults = true;
        this.recognition.maxAlternatives = 1;
        this.recognition.onstart = async () => {
            this.isListening = true;
            this.voiceNoticeText = '';
            await this.service.render();
            setTimeout(() => this.scrollToBottom(), 80);
        };
        this.recognition.onresult = (recognitionEvent: any) => this.handleVoiceResult(recognitionEvent);
        this.recognition.onerror = async (recognitionError: any) => {
            const shouldSend = this.voiceShouldSendOnEnd && this.hasRecognizedVoiceText();
            this.voiceShouldSendOnEnd = false;
            this.clearVoiceSilenceTimer();
            this.isListening = false;

            if (shouldSend) {
                await this.sendRecognizedMessage();
                return;
            }

            const error = recognitionError?.error || '';
            if (this.isVoicePermissionError(error)) {
                await this.showVoicePermissionBlockedNotice();
                return;
            }

            await this.showVoiceNotice(this.voiceErrorMessage(error));
        };
        this.recognition.onend = async () => {
            const shouldSend = this.voiceShouldSendOnEnd;
            this.voiceShouldSendOnEnd = false;
            this.clearVoiceSilenceTimer();
            this.isListening = false;
            await this.service.render();

            if (shouldSend) {
                await this.sendRecognizedMessage();
            }
        };

        try {
            this.recognition.start();
            this.isListening = true;
            await this.service.render();
            setTimeout(() => this.scrollToBottom(), 80);
        } catch {
            this.isListening = false;
            await this.showVoiceNotice('음성 인식을 시작할 수 없습니다. 잠시 후 다시 시도해 주세요.');
        }
    }

    private async handleVoiceResult(recognitionEvent: any) {
        let finalText = '';
        let interimText = '';

        for (let index = 0; index < recognitionEvent.results.length; index++) {
            const result = recognitionEvent.results[index];
            const transcript = result[0]?.transcript?.trim();
            if (!transcript) continue;

            if (result.isFinal) {
                finalText = this.joinVoiceText(finalText, transcript);
            } else {
                interimText = this.joinVoiceText(interimText, transcript);
            }
        }

        this.voiceFinalText = finalText;
        this.voiceInterimText = interimText;
        this.inputText = this.composeVoiceInput();
        this.syncVoiceInputField();

        if (this.hasRecognizedVoiceText()) {
            this.restartVoiceSilenceTimer();
        }

        await this.service.render();
        this.syncVoiceInputField();
        setTimeout(() => this.scrollToBottom(), 50);
    }

    private restartVoiceSilenceTimer() {
        this.clearVoiceSilenceTimer();
        this.voiceSilenceTimer = setTimeout(() => {
            this.voiceShouldSendOnEnd = true;
            this.stopVoiceRecognition(true);
        }, this.voiceSilenceMs);
    }

    private clearVoiceSilenceTimer() {
        if (!this.voiceSilenceTimer) return;

        clearTimeout(this.voiceSilenceTimer);
        this.voiceSilenceTimer = null;
    }

    private stopVoiceRecognition(sendOnEnd: boolean) {
        if (!this.recognition || !this.isListening) return;

        this.voiceShouldSendOnEnd = sendOnEnd;
        this.clearVoiceSilenceTimer();

        try {
            this.recognition.stop();
        } catch {
            this.isListening = false;
        }
    }

    private destroySpeechRecognition() {
        if (!this.recognition) return;

        this.voiceShouldSendOnEnd = false;
        this.recognition.onstart = null;
        this.recognition.onresult = null;
        this.recognition.onerror = null;
        this.recognition.onend = null;

        try {
            this.recognition.stop();
        } catch { }

        this.recognition = null;
        this.isListening = false;
    }

    private async sendRecognizedMessage() {
        if (this.voiceInterimText.trim()) {
            this.voiceFinalText = this.joinVoiceText(this.voiceFinalText, this.voiceInterimText);
        }
        this.voiceInterimText = '';
        this.inputText = this.composeVoiceInput();
        this.syncVoiceInputField();

        if (this.hasRecognizedVoiceText()) {
            await this.sendMessage();
        }

        this.voiceBaseText = '';
        this.voiceFinalText = '';
        this.voiceInterimText = '';
    }

    private composeVoiceInput(): string {
        return [this.voiceBaseText, this.voiceFinalText, this.voiceInterimText]
            .map(text => text.trim())
            .filter(Boolean)
            .join(' ');
    }

    private joinVoiceText(base: string, text: string): string {
        return [base, text]
            .map(value => value.trim())
            .filter(Boolean)
            .join(' ');
    }

    private hasRecognizedVoiceText(): boolean {
        return !!this.composeVoiceInput().trim();
    }

    private getSpeechRecognitionConstructor(): any {
        if (typeof window === 'undefined') return null;
        return (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition || null;
    }

    private async showVoiceNotice(message: string, persist: boolean = false) {
        this.clearVoiceNotice();
        this.voiceNoticeText = message;
        await this.service.render();
        setTimeout(() => this.scrollToBottom(), 50);
        if (persist) return;

        this.voiceNoticeTimer = setTimeout(async () => {
            this.voiceNoticeText = '';
            await this.service.render();
        }, 3000);
    }

    private async showVoicePermissionBlockedNotice() {
        this.clearVoiceNotice();
        this.voicePermissionBlocked = true;
        this.voiceNoticeText = '마이크가 허용되지 않았습니다.';
        await this.service.render();
        setTimeout(() => this.scrollToBottom(), 50);
    }

    private clearVoiceNotice() {
        if (this.voiceNoticeTimer) {
            clearTimeout(this.voiceNoticeTimer);
            this.voiceNoticeTimer = null;
        }
        this.voiceNoticeText = '';
        this.voicePermissionBlocked = false;
    }

    private voiceErrorMessage(error: string): string {
        if (this.isVoicePermissionError(error)) {
            return '마이크가 허용되지 않았습니다.';
        }

        if (error === 'no-speech') {
            return '음성이 감지되지 않았습니다.';
        }

        if (error === 'audio-capture') {
            return '사용 가능한 마이크를 찾을 수 없습니다.';
        }

        return '음성 인식 연결을 시작하지 못했습니다.';
    }

    private isVoicePermissionError(error: string): boolean {
        return error === 'not-allowed' || error === 'service-not-allowed';
    }

    private syncVoiceInputField() {
        const input = document.querySelector('.chat-input') as HTMLInputElement | null;
        if (!input || input.value === this.inputText) return;

        input.value = this.inputText;
    }

    private syncChatViewport() {
        const page = document.querySelector('.chatbot-page') as HTMLElement | null;
        const composer = document.querySelector('.chat-composer') as HTMLElement | null;
        const bottomNav = document.querySelector('.bottom-nav') as HTMLElement | null;

        if (!page) return;

        const viewport = window.visualViewport;
        const viewportHeight = this.currentViewportHeight();
        if (!this.inputFocused) this.baseViewportHeight = viewportHeight;

        const keyboardOffset = this.inputFocused && viewport
            ? Math.ceil(Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop))
            : 0;
        const navHeight = bottomNav ? Math.ceil(bottomNav.getBoundingClientRect().height) : 0;
        const composerHeight = composer ? Math.ceil(composer.getBoundingClientRect().height) : 0;
        const coarsePointer = window.matchMedia ? window.matchMedia('(pointer: coarse)').matches : false;
        const resizedKeyboard = this.inputFocused && this.baseViewportHeight > 0
            ? this.baseViewportHeight - viewportHeight > 80
            : false;
        const keyboardOverlay = keyboardOffset > 12;
        const keyboardActive = this.inputFocused && (keyboardOverlay || resizedKeyboard || (!viewport && coarsePointer));
        const navOffset = keyboardActive ? 0 : navHeight;
        const composerBottom = keyboardOverlay ? keyboardOffset : (keyboardActive ? 0 : navHeight);

        page.style.setProperty('--chat-keyboard-offset', `${keyboardOffset}px`);
        page.style.setProperty('--chat-nav-offset', `${navOffset}px`);
        page.style.setProperty('--chat-composer-bottom', `${composerBottom}px`);
        page.style.setProperty('--chat-composer-height', `${composerHeight}px`);
        this.toggleKeyboardMode(keyboardActive);
    }

    private resetChatViewport() {
        const page = document.querySelector('.chatbot-page') as HTMLElement | null;
        if (!page) return;

        page.style.removeProperty('--chat-keyboard-offset');
        page.style.removeProperty('--chat-nav-offset');
        page.style.removeProperty('--chat-composer-bottom');
        page.style.removeProperty('--chat-composer-height');
    }

    private toggleKeyboardMode(active: boolean) {
        const container = document.querySelector('.app-container') as HTMLElement | null;
        document.body.classList.toggle('chat-keyboard-open', active);
        if (container) container.classList.toggle('chat-keyboard-open', active);
    }

    private currentViewportHeight(): number {
        return window.visualViewport ? window.visualViewport.height : window.innerHeight;
    }

    private handleOutsidePointer(event: Event) {
        const target = event.target as HTMLElement | null;
        if (!target) return;
        if (target.closest('.chat-input') || target.closest('.chat-send-button') || target.closest('.chat-voice-button')) return;

        const active = document.activeElement as HTMLElement | null;
        if (active && active.closest('.chat-composer')) {
            active.blur();
            return;
        }

        if (this.inputFocused) {
            this.inputFocused = false;
            this.syncChatViewport();
        }
    }

    private focusMessageInput() {
        const input = document.querySelector('.chat-input') as HTMLInputElement | null;
        if (input) input.focus({ preventScroll: true });
    }
}

export default PageChatbotComponent;